import { getTopPages } from "common/services/analytics.service";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col } from "reactstrap";

// The period is driven by the shared selector on the Activity Report page.
const TopPages = ({ typeOfRequest = "all" }: { typeOfRequest?: string }) => {
  const [topPages, setTopPages] = useState<any>([]);
  useEffect(() => {
    let cancelled = false;

    const fetchTopPages = async () => {
      try {
        const response: any = await getTopPages({ typeOfRequest });
        if (!cancelled && response && response.data) {
          setTopPages(response.data);
        }
      } catch (e) {
        if (!cancelled) setTopPages([]);
      }
    };
    fetchTopPages();

    return () => {
      cancelled = true;
    };
  }, [typeOfRequest]);

  return (
    <React.Fragment>
      <Col xl={4} md={6}>
        <Card className="card-height-100">
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Top Pages</h4>
          </CardHeader>
          <CardBody>
            <div className="table-responsive table-card">
              <table className="table align-middle table-borderless table-centered table-nowrap mb-0">
                <thead className="text-muted table-light">
                  <tr>
                    <th scope="col" style={{ width: "62" }}>
                      Page
                    </th>
                    <th scope="col">Visits</th>
                    <th scope="col">Users (%)</th>
                  </tr>
                </thead>
                <tbody>
                  {(topPages || []).map((item: any, index: any) => (
                    <tr key={index}>
                      <td>
                        {item.pageUrl ? (
                          <Link to={item.pageUrl}>{item.pageName}</Link>
                        ) : (
                          item.pageName
                        )}
                      </td>
                      <td>{item.visits}</td>
                      <td>{item.percentUsersVisited}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default TopPages;
